import React from 'react'

function QuotationBlock() {
  return (
    <div className="content-section home-area gold-back">
        <div className="container standard-tour-list text-center">
              <div className=" large-text">
                "I live and breathe South Africa. <br/>
                I can't wait to make you fall in love with our history, <br/>
                culture and amazing wildlife."
              </div>
              <div className="title-name-quote">
                - Stephenson Garakasha -
              </div>
        </div>
    </div>
  )
}

export default QuotationBlock